import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { Bau365FeatureBreadcrumbModule } from '@planone/bau365/feature-breadcrumb';
import { Bau365UiShellModule } from '@planone/bau365/ui-shell';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUiIconsModule } from '@planone/shared/ui-icons';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';

import { ContactPersonDetailsComponent } from './contact-person-details/contact-person-details.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUtilPipelinesModule,
    SharedUiElementsModule,
    SharedUiIconsModule,
    MatIconModule,
    Bau365UiShellModule,
    Bau365FeatureBreadcrumbModule,
  ],
  declarations: [ContactPersonDetailsComponent],
  exports: [ContactPersonDetailsComponent],
})
export class Bau365FeatureContactPersonModule {}
